import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["newSection", "existingSection", "newRadio", "existingRadio"]

  connect() {
    // Initialize with new contact mode by default
    this.toggleSections()
  }

  toggle(event) {
    this.toggleSections()
  }

  toggleSections() {
    const isNewMode = this.newRadioTarget.checked

    if (isNewMode) {
      this.newSectionTarget.classList.remove("hidden")
      this.existingSectionTarget.classList.add("hidden")
    } else {
      this.newSectionTarget.classList.add("hidden")
      this.existingSectionTarget.classList.remove("hidden")
    }
  }
}
